var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"container-section-game-code"}},_vm._l((_vm.newRandColorArr),function(data,key){return _c('div',{key:data + key,staticClass:"div-color",style:({ backgroundColor: data })})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }